import axios from '@/utils/axios'
import {getAuthorizationByRole, getBackendByRole} from '@/utils/role'

/**
 * 注册验证码
 */
export const register = () => {
  return axios({
    url: `${getBackendByRole()}/captcha/register`,
    method: 'get'
  })
}

/**
 * 拼图校验与登录
 */
export const login = form => {
  return axios({
    url: `${getBackendByRole()}/captcha/login`,
    method: 'post',
    headers: {
      'Authorization': getAuthorizationByRole()
    },
    data: form
  })
}

/**
 * 拼图校验与登录（手机号登录）
 */
export const phoneLogin = form => {
  return axios({
    url: `${getBackendByRole()}/captcha/phoneLogin`,
    method: 'post',
    headers: {
      'Authorization': getAuthorizationByRole()
    },
    data: form
  })
}



// WEBPACK FOOTER //
// ./src/api/common/auth/captcha.js